import React from "react";
import './TimePlan.css';

class TimePlan extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">معلومات عن الخطة الزمنية للدراسة فى المانيا - الحساب البنكى و تجديده</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/AhmedAdelHeikal/videos/2285172084867864'>لايف</a> مهم عن الدراسة فى المانيا
                                        <br/>
                                        محتوى الفيديو
                                        <br/>
                                        ١- الخطة الزمنية للدراسة فى المانيا
                                        <br/>
                                        ٢- الحساب البنكى و تجديده
                                        <br/>
                                        ٣- الرد على الاسئلة
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default TimePlan;
